/* eslint-disable max-len */
import { memo } from 'react';

function SmallTickIcon() {
  return (
    <svg
      width="9"
      height="8"
      viewBox="0 0 9 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.63364 1.0561C8.92653 1.34899 8.92653 1.82386 8.63364 2.11676L3.1621 7.5883L0.313406 4.73946C0.0205204 4.44656 0.020533 3.97169 0.313434 3.6788C0.606335 3.38591 1.08121 3.38593 1.37409 3.67883L3.16212 5.46695L7.57298 1.0561C7.86587 0.763202 8.34074 0.763202 8.63364 1.0561Z"
        fill="white"
      />
    </svg>
  );
}

export default memo(SmallTickIcon);
